import { render, staticRenderFns } from "./carAccidentListCom.vue?vue&type=template&id=1ee2001d&scoped=true"
import script from "./carAccidentListCom.vue?vue&type=script&lang=js"
export * from "./carAccidentListCom.vue?vue&type=script&lang=js"
import style0 from "./carAccidentListCom.vue?vue&type=style&index=0&id=1ee2001d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee2001d",
  null
  
)

export default component.exports